export default __webpack_public_path__ + "static/media/IBMPlexSerif-ExtraLight.9f10ed8c.ttf";